import { createAction } from '@ngrx/store';

export const showDarkTheme = createAction(
    '[Login Menu] Show Dark Theme',
);

export const setWideMode = createAction(
    '[Login Menu] Show Wide Mode',
);
